import { DeleteShortcutsValues } from 'src/components/ShortcutsDrawer/shortcutsSidebarConsts';
import { getModKeyState } from 'src/utils/KeyEventUtils';

export const useOSDetector = () => {
  const isMac = navigator.userAgent.includes('Mac');

  const isOSMetaKeyPressed = (ev: KeyboardEvent) => {
    if (isMac) {
      return getModKeyState(ev, 'Meta');
    }
    return getModKeyState(ev, 'Control');
  };

  const isOSDeleteKeyPressed = (
    event: KeyboardEvent | React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (isMac) {
      return event.key === DeleteShortcutsValues.MAC_OS_KEY;
    }
    return event.key === DeleteShortcutsValues.WINDOWS_KEY;
  };

  return {
    isOSMetaKeyPressed,
    isMac,
    isOSDeleteKeyPressed,
  };
};

// Use user agent to detect Safari browser
// https://stackoverflow.com/questions/7944460/detect-safari-browser
export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
